/* =============================================
   AmpBird Knowledge Center — interactions
   - Latest articles: display-pagination ("Load more") over
     server-rendered cards (SEO-safe: all cards in DOM).
   - Instant client-side filter on title + tags.
   Scoped to .akc-latest; resilient to load timing.
   ============================================= */
(function () {
  'use strict';

  function initLatest(wrap) {
    if (wrap.getAttribute('data-akc-init') === '1') return;
    wrap.setAttribute('data-akc-init', '1');

    var cards = Array.prototype.slice.call(wrap.querySelectorAll('.ak-card'));
    if (!cards.length) return;

    var filterInput = wrap.querySelector('.akc-latest__filter-input');
    var moreBtn = wrap.querySelector('.akc-latest__more-btn');
    var countEl = wrap.querySelector('.akc-latest__count');
    var emptyEl = wrap.querySelector('.akc-latest__empty');

    var pageSize = parseInt(wrap.getAttribute('data-page-size') || '9', 10);
    var batch = parseInt(wrap.getAttribute('data-batch') || '9', 10);
    var query = '';

    function visibleCards() {
      return cards.filter(function (c) {
        if (!query) return true;
        var t = (c.getAttribute('data-title') || '').toLowerCase();
        var tg = (c.getAttribute('data-tags') || '').toLowerCase();
        return t.indexOf(query) > -1 || tg.indexOf(query) > -1;
      });
    }

    function render() {
      var vis = visibleCards();
      vis.forEach(function (c, i) {
        c.style.display = i < pageSize ? '' : 'none';
      });
      // hide non-matching entirely
      cards.forEach(function (c) {
        if (vis.indexOf(c) === -1) c.style.display = 'none';
      });

      var n = vis.length;
      if (countEl) {
        countEl.textContent = n + (n === 1 ? ' article' : ' articles');
      }
      if (emptyEl) {
        emptyEl.style.display = n === 0 ? 'block' : 'none';
      }
      if (moreBtn) {
        moreBtn.style.display = n > pageSize ? '' : 'none';
      }
    }

    if (filterInput) {
      filterInput.addEventListener('input', function () {
        query = filterInput.value.toLowerCase().trim();
        pageSize = parseInt(wrap.getAttribute('data-page-size') || '9', 10);
        render();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        pageSize += batch;
        render();
      });
    }

    render();
  }

  function initAll() {
    var wraps = document.querySelectorAll('.akc-latest');
    Array.prototype.forEach.call(wraps, initLatest);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
